export default __webpack_public_path__ + "static/media/blog.7a77e404.jpg";